export default {
  baseURL: process.env.VUE_APP_BFF_URL
}
